<template>
  <div class="layerParentContainer">
    <div :class="this.overlayEnabled ? 'overlay' : ''"></div>
    <!-- ---------------------------------back button--------------------------------->
    <div class="backBtnContainer"  id="backButton" v-if="this.backEnabled" @click="backFunction">
       <el-button plain class="backBtn"><b-icon icon="chevron-left"></b-icon></el-button>
    </div>

    <!-- ---------------------------------undo redo button---------------------------->
    <div class="undoRedoContainerOuter" v-if="this.undoRedoVisible">
      <div class="undoRedoContainer">
        <el-button id="studio-app-undo-button" :disabled="!undoEnabled" :class="['navBarIcon', !undoEnabled ? 'iconNavBar-undo-disabled' : 'iconNavBar-undo']" circle
          @click="undoFunction" ><b-icon icon="arrow-counterclockwise"></b-icon> </el-button>
          <el-button id="studio-app-undo-button" :disabled="!redoEnabled" :class="['navBarIcon', !redoEnabled ? 'iconNavBar-undo-disabled' : 'iconNavBar-undo']" circle
          @click="redoFunction" ><b-icon icon="arrow-clockwise"></b-icon>  </el-button>
          <el-button type="text"  class="resetIcon"  v-if="deleteButtonEnabled" @click="deleteFunction"> <b-icon icon="trash"></b-icon></el-button>
      </div>
      <div class="" v-show="this.actionButtonEnabled&&actionButtonText&&!isMobileView">
      <el-button 
        type="primary"
        class="commonBtnDV" 
        id=""
        :disabled="!isCommonBtnVisible"
        @click="mainActionDependingOnState"
        >
        {{actionButtonText}}
        </el-button
      >
    </div>
    </div>

    <!-- ---------------------------------2D 3D button-------------------------------->
    <div :class="['Container2d3d',isTooltipShow&&'showOnOverlayMD']" v-if="this.viewChangeEnabled&&isMobileView">
      <div class="tooltipContainer3DBtn tooltip2DMobile" v-if="isTooltipShow" >
          <p class="tooltipText3d">
            Switch between 2D and 3D view here.
          </p>
          <div id="tooltipClose" @click="close2d3dTooltip" class="tooltipBtnCont">
            <p class="nextBtn" >
              Skip
            </p>          </div>
        </div>
      <div id="2dButton" :class="['Cont2d', btn2d == true ? 'cont2d3dActive' : '']" @click="switch2d">
        <p class="text2d">2D</p>
      </div>
      <div class="positionR">
        <div id="3dButton" :class="['Cont3d', btn3d == true ? 'cont2d3dActive' : '']" @click="switch3d">
          <p class="text3d">3D</p>
        </div>
       
      </div>
    </div>

    <!-- Solar Access and Irradiance Map -->
   
    <div class="ContainerSolaAccess" v-if="this.viewChangeEnabled&&isMobileView">
      <div :class="['tooltipContainerSolarAccessBtn',isSolarAccessTooltip?'change-bottom-solarAccess':'change-bottom-irradiance' ]" v-if="isSolarAccessTooltip||isIrradianceMapTooltip" >
          <p class="tooltipText3d">
            {{isSolarAccessTooltip?'View solar access of your modules ':'View irradiations on your roof'}}
          </p>
          <div id="solarIrradiance" @click="close2d3dTooltip" class="tooltipBtnCont">
            <p class="nextBtn" >
              Skip
            </p>          </div>
        </div>
      <div style="display: grid;row-gap: 16px;">
        <div id="solarAccess" :class="['icon-container',isSolarAccessTooltip&&'showOnOverlay']" @click="switchSolarAccess">
          <div :class="[solarAccess == true ? 'selectedSolarAccess' : '']">
            <img v-if="solarAccess" src="../../assets/solaraccesswhite.svg" alt="">
            <img v-else src="../../assets/solaraccess.svg" alt="">
          </div>
      </div>
      <div id="irradianceMap" :class="['icon-container',isIrradianceMapTooltip&&'showOnOverlay']" @click="switchIrradianceMap">
        <div :class="[irradianceMap == true ? 'selectedSolarAccess' : '']">
          <img v-if="irradianceMap" src="../../assets/irradiancewhite.svg" alt="">
          <img v-else="irradianceMap" src="../../assets/irradiancemap.svg" alt="">

        </div>
      </div>
      </div>
      </div>

      <!-- 2d 3d and other btns Desktop -->
       <div class="Container2d3dDV" v-if="this.viewChangeEnabled&&!isMobileView">
      <div class="ContainerSolarIrradiance">
        <div :class="['tooltipContainerSolarAccessBtn', 'bottomPosition' ,isSolarAccessTooltip?'solarAccessRight':'irradianceRight' ]" v-if="isSolarAccessTooltip||isIrradianceMapTooltip" >
          <p class="tooltipText3d">
            {{isSolarAccessTooltip?'View solar access of your modules ':'View irradiations on your roof'}}
          </p>
          <div id="solarIrradiance" @click="close2d3dTooltip" class="tooltipBtnCont">
            <p class="nextBtn" >
              Skip
            </p>          </div>
        </div>
        <div id="solarAccess" :class="['icon-container',isSolarAccessTooltip&&'showOnOverlay']" @click="switchSolarAccess">
          <div :class="[solarAccess == true ? 'selectedSolarAccess' : '']">
            <img v-if="solarAccess" src="../../assets/solaraccesswhite.svg" alt="">
            <img v-else src="../../assets/solaraccess.svg" alt="">
          </div>
      </div>
      <div id="irradianceMap" :class="['icon-container',isIrradianceMapTooltip&&'showOnOverlay']" @click="switchIrradianceMap">
        <div :class="[irradianceMap == true ? 'selectedSolarAccess' : '']">
          <img v-if="irradianceMap" src="../../assets/irradiancewhite.svg" alt="">
          <img v-else="irradianceMap" src="../../assets/irradiancemap.svg" alt="">

        </div>
      </div>
      </div>

        <div :class="['container2d3dbtns',isTooltipShow&&'showOnOverlay']" >
          <div class="tooltipContainer3DBtn tooltip2DDesktop" v-if="isTooltipShow" >
          <p class="tooltipText3d">
            Switch between 2D and 3D view here.
          </p>
          <div id="tooltipClose" @click="close2d3dTooltip" class="tooltipBtnCont">
            <p class="nextBtn" >
              Skip
            </p>          </div>
        </div>
      <div id="2dButton" :class="['Cont2d', btn2d == true ? 'cont2d3dActive' : '']" @click="switch2d">
        <p class="text2d">2D</p>
      </div>
      <div class="positionR">
        <div id="3dButton" :class="['Cont3d', btn3d == true ? 'cont2d3dActive' : '']" @click="switch3d">
          <p class="text3d">3D</p>
        </div>
       
      </div>
    </div>
    <div class="" v-show="this.actionButtonEnabled&&actionButtonText&&!isMobileView">
      <el-button 
        type="primary"
        class="commonBtnDV" 
        id=""
        :disabled="!isCommonBtnVisible"
        @click="mainActionDependingOnState"
        >
        {{actionButtonText}}
        </el-button>
    </div>
       </div>


    <!-- ---------------------------------sidebar------------------------------------->
    <Sidebar v-if="this.sidebarEnabled" />

    <!-- ---------------------------------zoom slider--------------------------------->
    <div :class="['sliderContainer',isMobileView?'sliderTopPositionMV':'sliderTopPositionDV']" v-show="this.zoomSliderEnabled&&!this.isObstructionHeightOpen">
      <div class="slider-demo-block" >
        <el-slider id="obstrSlider" v-model="this.studioStore.zoomValue" :min="1" :max="10" :show-tooltip="true" vertical height="240px" placement="right" @input="sliderChanged"/>
        <div class="sliderTooltipTwo" v-if="isNextSliderTooltipShow">
          <p class="tooltipText3d">
            Please use this slider to increase or decrease the size of the object.
          </p>
          <div class="tooltipBtnCont">
            <p class="nextBtn" @click="isNextSliderTooltipShow = false">
              Done
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- ---------------------------------rotation-bar slider------------------------->
    <div class="rotSliderContainer" v-show="this.rotationSliderEnabled&&!this.isObstructionHeightOpen ">
      <div class="main">
        <div class="slider-container">
    <el-slider
      v-model="this.studioStore.rotationValue"
      id="obstrRotationSlider"
      :min="0"
      :max="180"
      :step="15"
      :show-tooltip="false"
      class="custom-slider"
      @input="sliderRotated"
    />
    <div class="sliderTooltip" v-if="isFirstSliderTooltipShow">
              <p class="tooltipText3d">
                Please use this slider to rotate and align the rectangle to the object present on your rooftop.
              </p>
              <div class="tooltipBtnCont">
                <p class="nextBtn" @click="nextSliderTooltipShow()">
                  Next
                </p>
              </div>
            </div>
    <div
      class="custom-thumb"
      :style="{ left: `${(parseInt(this.studioStore.rotationValue)/180)*100 + '%'}` }"
    >
      {{ this.studioStore.rotationValue }}°
    </div>
  </div>
      </div>
    </div>

    <!-- ---------------------------------Floor input (app mode only)----------------->
    <FloorInput
      v-if="appFloorInputEnabled"
      :initialValue="infoFormData.floorValue || 1"
      @submit="handleFloorSubmit"
    />

    <!-- ---------------------------------No of building input button----------------->
    <div class="containerMD" v-if="this.floorInputEnabled">
      <InfoCollectionForm v-if="isMobileView" :isFooter="true" @updateBtnStatus="checkFormBtn"/>
      <el-dialog
            v-model="dialogVisible"
            title=" "
            width="390px"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            v-else
          >
          <InfoCollectionForm  :isFooter="false" @updateBtnStatus="checkFormBtn"/>

            <template #footer>
              <div class="dialog-footer">
                <el-button @click="backFunction" class="btn-content"
                  >Close</el-button
                >
                <el-button
                  type="primary"
                  class="btn-content btn-color"
                  :disabled="!formBtnDisabled"
                  @click="setInfoFormDataToStore"
                >
                  Draw Roof
                </el-button>
              </div>
            </template>
          </el-dialog>
      </div>
    <!-- ---------------------------------Calculate savings--------------------------->
    <CalculateSavings v-if="savingsEnabled&&isMobileView" />
    <el-dialog
            v-model="savingsEnabled"
            title=" "
            width="390px"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            v-else
          >
          <CalculateSavings v-if="savingsEnabled" />
          </el-dialog>


    <!-- ---------------------------------gif button---------------------------------->
    <div :class="['gifContainer', this.actionButtonEnabled ? 'topGifContainer' : '']" v-if="this.gifEnabled">
      <div class="positionR">
        <div class="bulbCont">
          <img :src="
            gifBtnToggle == true ? allIcon.get('cross') : allIcon.get('bulb')
          " class="bulbIcon" @click="gifBtnToggle = !gifBtnToggle" />
        </div>
        <div class="tooltipContainer" v-if="gifBtnToggle == true">
          <h4 class="tooltipHeading">{{ gifContent.heading }}</h4>
          <p class="tooltipText">
            {{ gifContent.text }}
          </p>
          <img :src="allIcon.get('Draw-roof')" class="gifImg" />
        </div>
      </div>
    </div>

    <!-- ---------------------------------common button------------------------------->
    <div class="bottomBtnContainer" v-show="this.actionButtonEnabled&&actionButtonText&&isMobileView">
      <el-button 
        type="primary"
        class="commonBtn" 
        id="mainButton"
        :disabled="!isCommonBtnVisible"
        @click="mainActionDependingOnState"
        >{{actionButtonText}}</el-button
      >
    </div>

    <!-- Obstruction Height -->
    <div class="containerMD" v-if="this.isObstructionHeightOpen&&isMobileView">
      <div class="info-container">
      <div class="info-content smLabel">
        <p class="inputLabel">Height Of Obstruction</p>
                <el-input
                :placeholder="'Enter Height'"
                v-model="obstructionHeight"
                type="number"
                :controls="false"
                @input="
                  handleInputValueChange(
                    obstructionHeight,
                    'obstruction_height')"
                class="no-arrow-buttons"
                @keydown="preventSpecialCharacters"
              >
              <template #append>
                  <div>
                    <span>Meters</span>
                  </div>
                </template>
              </el-input>
        <div
        v-if="disableObstructionHeight"
        class="warning"
      >
      Should be between 0.05 and 20.
      </div>
      </div>
      </div>
      <el-button 
        type="primary" 
        class="drwBtnBtnMD" 
        :disabled="disableObstructionHeight||!obstructionHeight" 
        @click="obstructionHeightEntered">
      Place Obstruction</el-button>
    </div>
    <el-dialog
            v-model="obstructionHeightVisible"
            title=" "
            width="272px"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            align-center
            v-else
          >
    <div class="containerDV" v-if="this.isObstructionHeightOpen&&!isMobileView">
      <div class="info-container">
      <div class="info-content smLabel">
        <p class="inputLabel">Height Of Obstruction</p>
                <el-input
                :placeholder="'Enter Height'"
                v-model="obstructionHeight"
                type="number"
                :controls="false"
                @input="
                  handleInputValueChange(
                    obstructionHeight,
                    'obstruction_height')"
                class="no-arrow-buttons"
                @keydown="preventSpecialCharacters"
              >
              <template #append>
                  <div>
                    <span>Meters</span>
                  </div>
                </template>
              </el-input>
        <div
        v-if="disableObstructionHeight"
        class="warning"
      >
      Should be between 0.05 and 20.
      </div>
      </div>
      </div>
      <div style="display: flex;justify-content: center;align-items: center;">

        <el-button 
          type="primary" 
          class="drwBtnBtnDV" 
          style="border:none"
          :disabled="disableObstructionHeight||!obstructionHeight" 
          @click="obstructionHeightEntered">
        Place Obstruction</el-button>
      </div>
    </div>
    </el-dialog>

    <!-- ---------------------------------Welcome card (app mode first visit)-------->
    <WelcomeCard
      v-if="welcomeEnabled"
      @get-started="handleWelcomeGetStarted"
    />

    <!-- ---------------------------------Delete confirmation (app mode only)------->
    <ConfirmDeleteDialog
      v-if="showDeleteConfirm"
      :message="deleteConfirmMessage"
      @confirm="confirmDelete"
      @cancel="cancelDelete"
    />

    <!-- Panel Settings sheet — App mode only, shown before panels are placed -->
    <PanelSettings
      v-if="panelSettingsEnabled"
      :saving="panelSettingsSaving"
      :saving-text="panelSettingsSavingText"
      @save-and-continue="handlePanelSettingsSave"
      @close="backFunction"
    />

    <!-- Global saving overlay: blocks interactions during placing/saving across states -->
    <div v-if="panelSettingsSaving" class="saving-overlay">
      <div class="saving-card">
        <div class="spinner" />
        <div class="saving-text">{{ panelSettingsSavingText || 'Saving...' }}</div>
      </div>
    </div>

  </div>
</template>

<script>
import utils from '@/pages/siteSurvey/utils';
import Sidebar from "./sidebar.vue";
import CalculateSavings from "./calculateSavings.vue";
import { useStudioStore } from "../store/studioStore";
import studioDataService from "../../services/studioDataService";
import appMode from "../../services/appMode";
import { postToRN } from "../../utils/rnBridge";
import {
  WELCOME_STATE,
  FLOOR_STATE,
  DRAWING_STATE,
  OBSTRUCTION_STATE,
  PANEL_SETTINGS_STATE,
  PANEL_VIEW_STATE,
  SAVINGS_STATE,
  REPORT_STATE,
  defaultComponentsData,
  DRAW_OBSTRUCTION,
} from "./constants";
import PanelSettings from './PanelSettings.vue';
import FloorInput from './FloorInput.vue';
import ConfirmDeleteDialog from './ConfirmDeleteDialog.vue';
import WelcomeCard from './WelcomeCard.vue';
import Obstruction from '../../core/Objects/Obstruction';
import { mapState,mapActions } from 'pinia';
import InfoCollectionForm from './InfoCollectionForm.vue';
import { useScreenSize } from '../../utils';
// import { solarCalculatorStore } from '../../pages/store/solarCalculator';

export default {
  components: {
    Sidebar,
    CalculateSavings,
    InfoCollectionForm,
    PanelSettings,
    FloorInput,
    ConfirmDeleteDialog,
    WelcomeCard,
  },

  data() {
    return {
      gifBtnToggle: false,
      btn2d: false,
      btn3d: true,
      isTooltipShow: false,
      studioStore: useStudioStore(),
      panelSettingsSaving: false,
      panelSettingsSavingText: '',
      zoomValue: 3,
      rotationValue: 0,
      floorValue: null,
      actionButtonText: "Done",
      zoomMin: 1,
      zoomMax: 10,
      gifContentForDrawing: {
        heading: "How to Draw a Roof",
        text: "Click on each corner of the roof you want draw.",
        gifSrc: "",
      },
      gifContentForObstruction: {
        heading: "Add Objects",
        text: "Select object from the menu and drag to place.",
        gifSrc: "",
      },
      gifContent: "",
      allIcon: utils.images,
      value1: 0,
      isFirstSliderTooltipShow: false,
      isNextSliderTooltipShow: false,
      infoFormData:{
        floorValue: null,
        supply_phase: 'Single Phase',
        tariff_rate: 7,
        monthly_bill: null,
        sanction_load: null,
      },
      inputTariffValue: 7,
      errorData:{
        monthly_bill:false,
        sanction_load:false,
        floorValue:false,
      },
      // Enables the 'View proposal' CTA only after a successful save
      designSaved: false,
      disableRadio:{
        isThreeDisabled:false,
        isSingleDisabled:false
      },
      obstructionHeight:null,
      disableObstructionHeight:false,
      solarAccess: false,
      irradianceMap:false,
      isSolarAccessTooltip: false,
      isIrradianceMapTooltip: false,
      formBtnDisabled:true,
      screenSize: useScreenSize(),
      value_rotate:90,
      // Delete confirmation dialog state (app mode only)
      showDeleteConfirm: false,
      deleteConfirmMessage: '',
      pendingDeleteType: null, // 'roof' or 'obstruction'
    };
  },

  computed: {
    // ...mapState(solarCalculatorStore, {
    //   calculatorData: (state) => state.CALCULATOR_DATA_STATE,
    // }),
    ...mapState(useStudioStore, {
       isObstructionHeightOpen: (state) => state.openObstructionHeight,
       obstructionType:(state) => state.obstructionType,
       gifBtnToggleStore: (state) => state.gifBtnToggle,
    }),
    currentAppState() {
      return this.studioStore.currentAppState;
    },
    currentObstructionType() {
      return this.studioStore.obstructionType;
    },
    //Visibility Functions
    welcomeEnabled() {
      return this.currentAppState === WELCOME_STATE && appMode.isAppMode();
    },
    overlayEnabled() {
      if (this.currentAppState === WELCOME_STATE) return false;
      if (this.currentAppState === FLOOR_STATE) return false;
      if (this.currentAppState === DRAWING_STATE) {
        if (this.gifBtnToggle === true) return true;
        return false;
      }
      if (this.currentAppState === OBSTRUCTION_STATE){
        if (this.gifBtnToggle === true) return true;
        if (this.isFirstSliderTooltipShow === true) return true;
        if (this.isNextSliderTooltipShow === true) return true;
        return false;
      }

      if (this.currentAppState === PANEL_SETTINGS_STATE) return false;
      if (this.currentAppState === PANEL_VIEW_STATE) {
        if (this.isTooltipShow||this.isSolarAccessTooltip||this.isIrradianceMapTooltip) return true;
        return false;
      }
      if(this.currentAppState === SAVINGS_STATE) return true;
      if(this.currentAppState === REPORT_STATE) return false;
      return false;
    },
    backEnabled() {
      if (this.panelSettingsSaving) return false;
      // Block back button when obstruction height dialog is open on mobile
      if (this.isObstructionHeightOpen && this.isMobileView) return false;
      // Block back while drawing an obstruction polygon until completed or cancelled
      if (
        this.currentAppState === OBSTRUCTION_STATE &&
        this.currentObstructionType === DRAW_OBSTRUCTION &&
        this.$stageInstance?.drawManager?.enabled
      ) {
        return false;
      }
      if(this.currentAppState === WELCOME_STATE) return false;
      if(this.currentAppState === FLOOR_STATE) return false;
      // Block back button while actively drawing roof polygon (points placed but not completed)
      if(this.currentAppState === DRAWING_STATE) {
        // If ANY points have been placed (1 or more) but roof not completed, block back button
        if (this.studioStore.anyPointsDrawn && !this.studioStore.basePolygonDrawn) {
          return false;
        }
        // Otherwise allow back (no points placed, or roof completed)
        return true;
      }
      if(this.currentAppState === OBSTRUCTION_STATE) return true;

      if(this.currentAppState === PANEL_SETTINGS_STATE) return true;
      if(this.currentAppState === PANEL_VIEW_STATE) return true;
      if(this.currentAppState === SAVINGS_STATE) return true;
      if(this.currentAppState === REPORT_STATE) return false;
      return true;
    },
    undoRedoVisible() {
      // Block undo/redo when obstruction height dialog is open on mobile
      if (this.isObstructionHeightOpen && this.isMobileView) return false;
      if(this.currentAppState === WELCOME_STATE) return false;
      if(this.currentAppState === FLOOR_STATE) return false;
      if(this.currentAppState === DRAWING_STATE) return true;
      if(this.currentAppState === OBSTRUCTION_STATE) return true;

      if(this.currentAppState === PANEL_SETTINGS_STATE) return false;
      if(this.currentAppState === PANEL_VIEW_STATE) return false;
      if(this.currentAppState === SAVINGS_STATE) return false;
      if(this.currentAppState === REPORT_STATE) return false;
      return true;
    },
    viewChangeEnabled() {
      if (this.panelSettingsSaving) return false;
      // Block view change when obstruction height dialog is open on mobile
      if (this.isObstructionHeightOpen && this.isMobileView) return false;
      if(this.currentAppState === WELCOME_STATE) return false;
      if(this.currentAppState === FLOOR_STATE) return false;
      if(this.currentAppState === DRAWING_STATE) return false;
      if(this.currentAppState === OBSTRUCTION_STATE) return false;
      if(this.currentAppState === PANEL_SETTINGS_STATE) return false;
      if(this.currentAppState === PANEL_VIEW_STATE) return true;
      if(this.currentAppState === SAVINGS_STATE) return false;
      if(this.currentAppState === REPORT_STATE) return false;
      return true;
    },
    zoomSliderEnabled() {
      if (this.panelSettingsSaving) return false;
      // Block zoom slider when obstruction height dialog is open on mobile
      if (this.isObstructionHeightOpen && this.isMobileView) return false;
      if(this.currentAppState === WELCOME_STATE) return false;
      if(this.currentAppState === FLOOR_STATE) return false;
      if(this.currentAppState === DRAWING_STATE) return false;
      if(this.currentAppState === OBSTRUCTION_STATE  && this.$stageInstance.currentSelectedObject instanceof Obstruction) return true;
      if(this.currentAppState === PANEL_SETTINGS_STATE) return false;
      if(this.currentAppState === PANEL_VIEW_STATE) return false;
      if(this.currentAppState === SAVINGS_STATE) return false;
      if(this.currentAppState === REPORT_STATE) return false;
      return true;
    },
    rotationSliderEnabled() {
      if (this.panelSettingsSaving) return false;
      // Block rotation slider when obstruction height dialog is open on mobile
      if (this.isObstructionHeightOpen && this.isMobileView) return false;
      if(this.currentAppState === WELCOME_STATE) return false;
      if(this.currentAppState === FLOOR_STATE) return false;
      if(this.currentAppState === DRAWING_STATE) return false;
      if(this.currentAppState === OBSTRUCTION_STATE  && this.$stageInstance.currentSelectedObject instanceof Obstruction) return true;
      if(this.currentAppState === PANEL_SETTINGS_STATE) return false;
      if(this.currentAppState === PANEL_VIEW_STATE) return false;
      if(this.currentAppState === SAVINGS_STATE) return false;
      if(this.currentAppState === REPORT_STATE) return false;
      return true;
    },
    panelSettingsEnabled() {
      return this.currentAppState === PANEL_SETTINGS_STATE && appMode.isAppMode();
    },
    deleteButtonEnabled() {
      // Only show delete button when there's actually something to delete
      if (this.currentAppState === DRAWING_STATE) {
        // Show delete button only if a roof polygon exists OR drawing has actual points placed
        const hasRoofPolygon = !!this.$stageInstance?.polygonModel;
        const hasPointsDrawn = this.$stageInstance?.drawManager?.enabled && this.$stageInstance?.drawManager?.numVertices > 0;
        return hasRoofPolygon || hasPointsDrawn;
      }
      if (this.currentAppState === OBSTRUCTION_STATE) {
        // Show delete button only if an obstruction is selected OR drawing has actual points placed
        const hasSelectedObstruction = this.$stageInstance?.currentSelectedObject instanceof Obstruction;
        const hasPointsDrawn = this.$stageInstance?.drawManager?.enabled && this.$stageInstance?.drawManager?.numVertices > 0;
        const isDrawingObstruction = this.currentObstructionType === DRAW_OBSTRUCTION && hasPointsDrawn;
        return hasSelectedObstruction || isDrawingObstruction;
      }
      return false;
    },
    sidebarEnabled() {
      if(this.currentAppState === WELCOME_STATE) return false;
      if(this.currentAppState === FLOOR_STATE) return false;
      if(this.currentAppState === DRAWING_STATE) return false;
      if(this.currentAppState === OBSTRUCTION_STATE){ 
        return this.isObstructionHeightOpen||(this.obstructionType==='drawObstruction')? false: true;
      }
      if(this.currentAppState === PANEL_SETTINGS_STATE) return false;
      if(this.currentAppState === PANEL_VIEW_STATE) return false;
      if(this.currentAppState === SAVINGS_STATE) return false;
      if(this.currentAppState === REPORT_STATE) return false;
      return true;
    },
    appFloorInputEnabled() {
      return this.currentAppState === FLOOR_STATE && appMode.isAppMode();
    },
    floorInputEnabled() {
      if(this.currentAppState === WELCOME_STATE) return false;
      if(this.currentAppState === FLOOR_STATE) return !appMode.isAppMode();
      if(this.currentAppState === DRAWING_STATE) return false;
      if(this.currentAppState === OBSTRUCTION_STATE) return false;
      if(this.currentAppState === PANEL_SETTINGS_STATE) return false;
      if(this.currentAppState === PANEL_VIEW_STATE) return false;
      if(this.currentAppState === SAVINGS_STATE) return false;
      if(this.currentAppState === REPORT_STATE) return false;
      return true;
    },
    savingsEnabled() {
      if(this.currentAppState === WELCOME_STATE) return false;
      if(this.currentAppState === FLOOR_STATE) return false;
      if(this.currentAppState === DRAWING_STATE) return false;
      if(this.currentAppState === OBSTRUCTION_STATE) return false;
      if(this.currentAppState === PANEL_SETTINGS_STATE) return false;
      if(this.currentAppState === PANEL_VIEW_STATE) return false;
      if(this.currentAppState === SAVINGS_STATE) return true;
      if(this.currentAppState === REPORT_STATE) return false;
      return true;
    },
    gifEnabled() {
      if(this.currentAppState === WELCOME_STATE) return false;
      if(this.currentAppState === FLOOR_STATE) return false;
      if(this.currentAppState === DRAWING_STATE) return true;
      if(this.currentAppState === OBSTRUCTION_STATE) return true;
      if(this.currentAppState === PANEL_SETTINGS_STATE) return false;
      if(this.currentAppState === PANEL_VIEW_STATE) return false;
      if(this.currentAppState === SAVINGS_STATE) return false;
      if(this.currentAppState === REPORT_STATE) return false;
      return true;
    },
    actionButtonEnabled() {
      if(this.currentAppState === WELCOME_STATE) return false;
      if(this.currentAppState === FLOOR_STATE) return false;
      if(this.currentAppState === DRAWING_STATE) return true;
      if(this.currentAppState === OBSTRUCTION_STATE) {
        return this.isObstructionHeightOpen? false: true;
      }
      if(this.currentAppState === PANEL_SETTINGS_STATE) return false;
      // In panel view, enable CTA only after design is saved
      if(this.currentAppState === PANEL_VIEW_STATE) return this.designSaved === true;
      if(this.currentAppState === SAVINGS_STATE) return false;
      if(this.currentAppState === REPORT_STATE) return false;
      return true;
    },
    undoEnabled() {
      return this.studioStore.undoEnabled;
    },
    redoEnabled(){
      return this.studioStore?.redoEnabled||false;
    },
    isCommonBtnVisible() {
      if(this.currentAppState === DRAWING_STATE) {
        if(this.studioStore.basePolygonDrawn){
          this.actionButtonText = "Next";
          return true;
        }
        if(this.studioStore.atleast3PointsDrawn){
         
          this.actionButtonText = "Complete";
          return true;
        }
        else {
          this.actionButtonText = "";
          return false;
        }
      }
      if(this.currentAppState === OBSTRUCTION_STATE) {
        this.actionButtonEnabled=false;
       if(this.obstructionType==="drawObstruction"){
          if(this.studioStore.atleast3PointsDrawn){
            this.actionButtonText = "Complete";    
            return true;
          }else{
            this.actionButtonText = "";
            return false;
          }
        }else   if(!this.studioStore.obstructionPlacedInScene){
          this.actionButtonText = "Continue Without Object";
        }
        else{
          this.actionButtonText = "Done";
        }
        return true;
      }
      if(this.currentAppState === PANEL_VIEW_STATE) {
        this.actionButtonText = appMode.isAppMode() ? "View proposal" : "Generate Result";
        return true;
      }
      return false;
    },
    checkDrawRoofDisabled() {
      const errorData={};
// Check if all values are provided
for (const key in this.infoFormData) {
  if (this.infoFormData[key] === null || this.infoFormData[key] === '' || this.infoFormData[key] === undefined) {
    errorData[key]=true;
  }else{
    errorData[key]=false;
  }
}
if(Object.values(errorData).every(value => value === false)){
  // Validate specific fields with range constraints
  if(this.infoFormData.floorValue && parseInt(this.infoFormData.floorValue) && this.infoFormData.floorValue<0 && this.infoFormData.floorValue>50) {
    errorData.floorValue = true;
        }else{
          errorData.floorValue = false;
        }
  if (this.infoFormData.sanction_load !== null && (parseInt(this.infoFormData.sanction_load)<1 || parseInt(this.infoFormData.sanction_load )>100)) {
    errorData.sanction_load = true;
  }else{
   errorData.sanction_load = false;
}
 if(this.infoFormData.monthly_bill !== null && (parseInt(this.infoFormData.monthly_bill)<1 || parseInt(this.infoFormData.monthly_bill )>9999999)){
  errorData.monthly_bill = true;
 }else{
  errorData.monthly_bill = false;
 }
}
const anyTrue = Object.values(errorData).every(value => value === false);
return anyTrue; // Validation passed
    },
    isMobileView(){
     return this.screenSize.isMobile ;
    },
    dialogVisible(){
      return this.floorInputEnabled && !this.screenSize.isMobile;
    },
    obstructionHeightVisible(){
      return this.isObstructionHeightOpen && !this.screenSize.isMobile;
    }
  },

  async mounted() {
    let appState;
    let infoFormData;

    if (appMode.isAppMode()) {
      // APP MODE: read state from studioDataService (loaded from API)
      appState = studioDataService.getCurrentAppState() || localStorage.getItem('currentAppState');
      infoFormData = studioDataService.getInfoFormData();
    } else {
      // WEB MODE: read state from localStorage (original dev behavior)
      appState = localStorage.getItem('currentAppState');
      const componentData = localStorage.getItem('componentData');
      if (componentData) {
        infoFormData = JSON.parse(componentData)?.infoData || null;
      }
    }

    if (infoFormData) {
      this.infoFormData = { ...this.infoFormData, ...infoFormData };
      this.$stageInstance.floorValue = this.infoFormData?.floorValue || null;
      if(this.infoFormData?.sanction_load){
        if(this.infoFormData?.sanction_load<=3){
          this.disableRadio.isSingleDisabled=false;
          this.disableRadio.isThreeDisabled=true;
        }else if(this.infoFormData?.sanction_load>5){
          this.disableRadio.isSingleDisabled=true;
          this.disableRadio.isThreeDisabled=false;
        }else{
          this.disableRadio.isSingleDisabled=false;
          this.disableRadio.isThreeDisabled=false;
        }
      }
    }

    // Determine initial state
    let resolvedState;
    if (appState === null || appState === 'FLOOR_STATE' || appState === FLOOR_STATE) {
      // In app mode, show welcome card on first visit (new design with no saved design_details)
      if (appMode.isAppMode() && studioDataService.isNewDesign()) {
        resolvedState = WELCOME_STATE;
      } else {
        resolvedState = FLOOR_STATE;
      }
    } else {
      resolvedState = appState;
    }

    this.studioStore.$patch({ currentAppState: resolvedState });

    // Clear undo/redo history when loading saved designs
    // Undo/redo should only be enabled after user makes changes
    if (appState && appState !== 'FLOOR_STATE' && appState !== FLOOR_STATE && appState !== WELCOME_STATE) {
      if (typeof this.$stageInstance.clearUndoRedoHistory === 'function') {
        this.$stageInstance.clearUndoRedoHistory();
      }
    }

    // Tooltips: only on first-time forward flow, never on load of saved design
    // All tooltip flags remain false (set in data()) — they'll be set to true
    // only during forward-flow state transitions in mainActionDependingOnState()
    // and handlePanelSettingsSave() when it's the first visit.

    if(this.currentAppState === DRAWING_STATE){
      this.gifContent = this.gifContentForDrawing;
      if(!(this.$stageInstance.polygonModel)){
        this.$stageInstance.newPolygonModel(this.infoFormData.floorValue);
      }
      // In roof drawing state: prevent selecting/moving obstructions
      if (typeof this.$stageInstance.disableObstructionSelection === 'function') {
        this.$stageInstance.disableObstructionSelection();
      }
    }
    if (this.currentAppState === OBSTRUCTION_STATE) {
      this.gifContent = this.gifContentForObstruction;
      // Ensure drag controls are properly set up for obstruction selection
      this.enterObstructionState();
      // Allow selecting/moving obstructions in obstruction state
      if (typeof this.$stageInstance.enableObstructionSelection === 'function') {
        this.$stageInstance.enableObstructionSelection();
      }
      // Don't show slider tooltips on reload — only during forward flow
      this.isFirstSliderTooltipShow = false;
      return true;
    }
    if(this.currentAppState===PANEL_VIEW_STATE) {
      this.isTooltipShow = false;
      const vm = this;
      setTimeout(() => {
        vm.addTouchEvents();
      }, 100);
      // When loading a saved design that's already in PANEL_VIEW_STATE,
      // panels were already restored by loadStage → loadObject chain.
      // Do NOT re-place panels, auto-save, switch to 3D, or fetch solar data.
      // Those actions should only happen during the normal forward flow
      // (new design or after PANEL_SETTINGS_STATE → Save & Continue).

      // Sync CTA button state with actual camera mode on load
      // The camera is always initialized as 2D (orthographic) in App.js,
      // but the UI defaults to 3D selected. This fixes the mismatch.
      const cameraType = this.$stageInstance?.cameraManager?.getCameraType();
      if (cameraType === 'orthographic') {
        this.btn2d = true;
        this.btn3d = false;
      } else if (cameraType === 'perspective') {
        this.btn2d = false;
        this.btn3d = true;
      }
      // If we loaded directly into PANEL_VIEW_STATE from a saved design,
      // enable the CTA immediately; otherwise it will be enabled post-save.
      if (appMode.isAppMode()) {
        this.designSaved = !studioDataService.isNewDesign();
      } else {
        this.designSaved = !!localStorage.getItem('stageData');
      }
    }
    if(this.currentAppState === SAVINGS_STATE) this.isTooltipShow = false;
  },
  created(){
    this.screenSize.setupListener();
  },
  beforeDestroy() {
    this.screenSize.removeListener();
  },

  methods: {
    ...mapActions(useStudioStore, {
      setIsObstructionHeightOpen: "OPEN_OBSTRUCTION_HEIGHT",
      setObstructionHeight:"SET_OBSTRUCTION_HEIGHT",
      setInfoFormDataToStore: "SET_INFORMATION_FORM_DATA_STORE",
      setObstructionType:"SET_OBSTRUCTION_TYPE",
    }),
    // ...mapActions(solarCalculatorStore, {
    //   UPDATE_CALCULATOR_DATA: "UPDATE_CALCULATOR_DATA",
    // }),
    nextSliderTooltipShow(){
      this.isFirstSliderTooltipShow = false;
      this.isNextSliderTooltipShow = true;
    },

    sliderBarRotation() {
      // The rotation slider now uses el-slider with v-model binding and
      // a custom-thumb overlay. No manual DOM manipulation needed.
    },
    // Welcome card handler
    handleWelcomeGetStarted() {
      this.studioStore.$patch({ currentAppState: FLOOR_STATE });
      this.setAppStateInLocalStorage(FLOOR_STATE);
    },

    // Helper method to properly set up drag controls when entering OBSTRUCTION_STATE
    // This ensures polygon selection is disabled so obstructions can be clicked and selected
    enterObstructionState() {
      if (this.$stageInstance?.dragControls) {
        this.$stageInstance.dragControls.disablePolygon();
        this.$stageInstance.dragControls.activate();
      }
    },

    // First-visit check: persisted per contact (app) or globally (web) in localStorage
    _markStateVisited(stateKey) {
      const scope = appMode.isAppMode() ? (appMode.getContactId() || 'global') : 'global';
      const key = `arkaTipSeen_v1_${scope}_${stateKey}`;
      if (localStorage.getItem(key)) return false;
      localStorage.setItem(key, '1');
      return true;
    },

    //Action functions
    handleFloorSubmit(floorValue) {
      // App-mode only: simplified floor input → transition to drawing
      this.infoFormData.floorValue = floorValue;
      this.studioStore.infoFormData.floorValue = floorValue;
      this.$stageInstance.floorValue = floorValue;

      // Persist floor value
      this.setFloorValueInLocalStorage(this.infoFormData);
      studioDataService.setInfoFormData(this.infoFormData);

      // Transition to drawing state
      this.studioStore.$patch({ currentAppState: DRAWING_STATE });
      if (!this.studioStore.basePolygonDrawn) {
        this.$stageInstance.newPolygonModel(floorValue);
      } else {
        this.$stageInstance.polygonModel.updateHeightOnFloorChange(floorValue);
      }
      this.setAppStateInLocalStorage(DRAWING_STATE);
      this.gifContent = this.gifContentForDrawing;
      if (this._markStateVisited('drawing')) {
        this.gifBtnToggle = true;
      }
    },
    floorsEntered() {
      this.studioStore.$patch({
        currentAppState: DRAWING_STATE,
      });
      if (this.currentAppState === DRAWING_STATE) {
        if(!this.studioStore.basePolygonDrawn){
          this.$stageInstance.newPolygonModel(this.infoFormData.floorValue);
        }
        else {
          this.$stageInstance.polygonModel.updateHeightOnFloorChange(this.infoFormData.floorValue);
          this.$stageInstance.floorValue = this.infoFormData.floorValue;
        }
      }
      this.setFloorValueInLocalStorage(this.infoFormData);
      this.setAppStateInLocalStorage(DRAWING_STATE);
      this.gifContent = this.gifContentForDrawing;
      if (this._markStateVisited('drawing')) {
        this.gifBtnToggle = true;
      }
    },
    backFunction() {
      // Guard: prevent navigation while an obstruction polygon is being drawn
      if (
        this.currentAppState === OBSTRUCTION_STATE &&
        this.currentObstructionType === DRAW_OBSTRUCTION &&
        this.$stageInstance?.drawManager?.enabled
      ) {
        return this.nullFunc;
      }
      if (this.currentAppState === FLOOR_STATE) {
        this.$router.push({ name: 'mapForDesignTool' });
      } else if (this.currentAppState === DRAWING_STATE) {
        if (this.$stageInstance.drawManager.enabled) {
          this.$stageInstance.drawManager.resetDrawManager();
        }
        if (typeof this.$stageInstance.disableObstructionSelection === 'function') {
          this.$stageInstance.disableObstructionSelection();
        }
        this.studioStore.$patch({ currentAppState: FLOOR_STATE });
        this.setAppStateInLocalStorage(FLOOR_STATE);
      } else if (this.currentAppState === OBSTRUCTION_STATE) {
        this.$stageInstance.dragControls.enablePolygon();
        if (typeof this.$stageInstance.disableObstructionSelection === 'function') {
          this.$stageInstance.disableObstructionSelection();
        }
        this.studioStore.$patch({ currentAppState: DRAWING_STATE });
        this.gifContent = this.gifContentForDrawing;
        this.setAppStateInLocalStorage(DRAWING_STATE);
      } else if (this.currentAppState === PANEL_SETTINGS_STATE) {
        if (this.panelSettingsSaving) return;
        this.studioStore.$patch({ currentAppState: OBSTRUCTION_STATE });
        this.setAppStateInLocalStorage(OBSTRUCTION_STATE);
        // Ensure drag controls are properly set up for obstruction selection
        this.enterObstructionState();
        if (typeof this.$stageInstance.enableObstructionSelection === 'function') {
          this.$stageInstance.enableObstructionSelection();
        }
      } else if (this.currentAppState === PANEL_VIEW_STATE) {
        // Reset tooltip/overlay flags so they don't persist into the next visit
        this.isTooltipShow = false;
        this.isSolarAccessTooltip = false;
        this.isIrradianceMapTooltip = false;
        // Also ensure overlays are disabled when leaving panel view
        this.solarAccess = false;
        this.irradianceMap = false;
        if (this.$stageInstance) {
          this.$stageInstance.updateSolarAccess(false);
          this.$stageInstance.updateIrradianceMap(false);
          if (typeof this.$stageInstance.clearIrradianceAndAccess === 'function') {
            this.$stageInstance.clearIrradianceAndAccess();
          }
        }
        // Since we are leaving panel view, gate CTA again until next successful save
        this.designSaved = false;

        // 3D mode is exclusive to PANEL_VIEW_STATE.  Always revert to 2D before
        // leaving so every other state (OBSTRUCTION, PANEL_SETTINGS, DRAWING)
        // sees the correct 2D scene.  switch2d() handles:
        //   – scene rotation back to XY plane
        //   – orthographic camera activation
        //   – polygon/obstruction mesh 2D swap
        //   – camera fit
        // It must run BEFORE we dispose the controlsManager, because it uses
        // the existing 2D OrbitControls for the transition.
        this.switch2d();

        // Now dispose 3D/2D OrbitControls so their event listeners are removed
        // from the DOM.  ControlsManager will be re-created fresh when the user
        // enters PANEL_VIEW_STATE again via initialize2D_3DControls().
        if (this.$stageInstance.controlsManager) {
          if (this.$stageInstance.controlsManager._2dControls) this.$stageInstance.controlsManager._2dControls.dispose();
          if (this.$stageInstance.controlsManager._3dControls) this.$stageInstance.controlsManager._3dControls.dispose();
          this.$stageInstance.controlsManager = null;
        }

        this.$stageInstance.removePanels();

        const targetState = appMode.isAppMode() ? PANEL_SETTINGS_STATE : OBSTRUCTION_STATE;

        // Properly set up drag controls when entering OBSTRUCTION_STATE
        if (targetState === OBSTRUCTION_STATE) {
          this.enterObstructionState();
          if (typeof this.$stageInstance.enableObstructionSelection === 'function') {
            this.$stageInstance.enableObstructionSelection();
          }
        } else {
          // In PANEL_SETTINGS_STATE the user interacts with the sheet, not the canvas.
          // Deactivate dragControls to prevent event.preventDefault() blocking UI.
          this.$stageInstance.dragControls.deactivate();
        }

        this.studioStore.$patch({ currentAppState: targetState });
        this.gifContent = this.gifContentForObstruction;
        this.setAppStateInLocalStorage(targetState);
        if (!appMode.isAppMode()) {
          setTimeout(() => { this.sliderBarRotation(); }, 50);
        }
      } else if (this.currentAppState === SAVINGS_STATE) {
        this.studioStore.$patch({ currentAppState: PANEL_VIEW_STATE });
        this.setAppStateInLocalStorage(PANEL_VIEW_STATE);
      }
    },
    async mainActionDependingOnState() {
      if (this.currentAppState === FLOOR_STATE) {
        // this.studioStore.$patch({undoEnabled: false});
        return this.nullFunc;
      }
      if (this.currentAppState === DRAWING_STATE) {
        if (this.studioStore.basePolygonDrawn) {
          this.studioStore.$patch({
            currentAppState: OBSTRUCTION_STATE,
          });
          this.setAppStateInLocalStorage(OBSTRUCTION_STATE);
          this.gifContent = this.gifContentForObstruction;
          // Ensure drag controls are properly set up for obstruction selection
          this.enterObstructionState();
          if (typeof this.$stageInstance.enableObstructionSelection === 'function') {
            this.$stageInstance.enableObstructionSelection();
          }
          // Show obstruction tooltips only on first visit
          if (this._markStateVisited('obstruction')) {
            this.gifBtnToggle = true;
            this.isFirstSliderTooltipShow = true;
          }
          this.studioStore.$patch({undoEnabled: true});
        }
        else if (this.studioStore.atleast3PointsDrawn) {
          if (this.$stageInstance.drawManager.enabled) {
            this.$stageInstance.drawManager.onComplete();
            this.studioStore.$patch({basePolygonDrawn: true});
            this.studioStore.$patch({undoEnabled: false});
          }
        }
        return this.nullFunc;
      }
      if (this.currentAppState === OBSTRUCTION_STATE) {
        if (this.studioStore.atleast3PointsDrawn&&this.obstructionType==="drawObstruction") {
          if (this.$stageInstance.drawManager.enabled) {
            this.$stageInstance.drawManager.onComplete();
            this.studioStore.$patch({basePolygonDrawn: false});
            this.studioStore.$patch({undoEnabled: false});
            this.setObstructionType(null);
            this.studioStore.$patch({obstructionPlacedInScene:true});
          }
        }else{
          // In app mode, go to Panel Settings before placing panels
          if (appMode.isAppMode()) {
            this.studioStore.$patch({ currentAppState: PANEL_SETTINGS_STATE });
            this.setAppStateInLocalStorage(PANEL_SETTINGS_STATE);
            return;
          }
          // WEB MODE: show global saving overlay during placePanels()
          this.panelSettingsSaving = true;
          this.panelSettingsSavingText = 'Placing panels and saving...';
          this.$stageInstance.placePanels().then(async () => {
            this.studioStore.$patch({
              currentAppState: PANEL_VIEW_STATE,
            });
            this.$stageInstance.deselectOtherSelectedMeshes(this.$stageInstance.ground);
            this.$stageInstance.dragControls.deactivate();
            this.setAppStateInLocalStorage(PANEL_VIEW_STATE);
            const vm = this;
            setTimeout(() => {
              vm.addTouchEvents();
            }, 100);
            this.$stageInstance.initialize2D_3DControls();
            this.switch3d();
            // Mark design as saved → enable 'View proposal' CTA
            this.designSaved = true;
            // Show panel view tooltips only on first visit
            if (this._markStateVisited('panelView')) {
              if (this.isMobileView) {
                this.isTooltipShow = true;
              } else {
                this.isSolarAccessTooltip = true;
              }
            }
            // Hide overlay immediately and show success toast
            this.panelSettingsSaving = false;
            this.panelSettingsSavingText = '';
            this.$message({ showClose: true, message: 'Design saved', type: 'success', center: true });
            // Call the API to store heatMap and SolarAccess.
            await this.$stageInstance.fetchIrradianceAndAccess();
            return this.nullFunc;
          }, (error) => {
            // Hide overlay immediately and show failure toast
            this.panelSettingsSaving = false;
            this.panelSettingsSavingText = '';
            this.$message({ showClose: true, message: 'Design not saved', type: 'error', center: true });
            console.error(error);
          });
        }
      }
      if (this.currentAppState === PANEL_VIEW_STATE) {
          if (appMode.isAppMode()) {
              // Guard: prevent duplicate PORTAL_EXIT from touch + synthetic click double-fire on mobile
              if (this._portalExitSent) return this.nullFunc;
              this._portalExitSent = true;
              // APP MODE: safely exit the portal back to ArkaGo
              postToRN('PORTAL_EXIT', {
                  contactId: window.__arkaContactId ?? appMode.getContactId(),
              });
              return this.nullFunc;
          }
          // WEB MODE: navigate to solar calculator (original behavior)
          this.$router.push('/solarCalculator');
          this.switch3d();
          // RESET FUNCTION REQUIRES DELAY
          if (this.$stageInstance.controlsManager) {
            this.$stageInstance.controlsManager.reset();
            this.$stageInstance.controlsManager._2dControls.disable();
            this.$stageInstance.controlsManager._3dControls.disable();
          }
          // TRY CALLING WITH DELAY WOULD WORK BT STETIMEOUT
          setTimeout(() => {
            this.$stageInstance.saveCanvasImage();
          }, 100);
          this.studioStore.$patch({
            currentAppState: SAVINGS_STATE,
          });
          this.setAppStateInLocalStorage(SAVINGS_STATE);
          return this.nullFunc;
      }
      return null;
    },
    async handlePanelSettingsSave({ panel, inverter, inverterQuantity }) {
      this.panelSettingsSaving = true;
      this.panelSettingsSavingText = 'Placing panels and saving...';

      // Build appPanelConfig from the selected API panel object.
      // Master data (?old=true) puts dimensions in `characteristics`.
      // report_json format puts them in `moduleProperties`.
      // Always fall back to sensible defaults so moduleLength/Width are never 0.
      if (panel) {
        const ch = panel.characteristics || {};     // master data format
        const mp = panel.moduleProperties  || {};   // report_json format

        // mm → m conversion: values > 100 are assumed to be in mm
        const toM = (v) => (v != null && v > 0 ? (v > 100 ? v / 1000 : v) : 0);

        const lengthM = toM(ch.length) || toM(mp.length) || toM(panel.length) || 1.632;
        const widthM  = toM(ch.width)  || toM(mp.width)  || toM(panel.width)  || 0.995;

        // Wattage: p_mp_ref is in W; moduleProperties.capacity is in kW
        const pmpRef       = ch.p_mp_ref      || (mp.capacity ? mp.capacity * 1000 : 0) || 260;
        const manufacturer = ch.manufacturer  || panel.brand   || '';
        const cellType     = ch.cell_type     || mp.cell_type  || 'Polycrystalline';
        const cellNumber   = ch.cell_number   || mp.cell_number || 60;
        const vMax         = ch.v_max         || mp.v_max       || 1000;
        const series       = ch.series        || panel.model    || '';

        // Preserve API-sourced tilt (set during loadStage from contactDataStore/report_json).
        // Tilt is no longer a user-editable field; azimuth is always derived from the
        // associated PolygonModel by Subarray.getFixedMountProperties().
        const existingTilt = this.$stageInstance.appPanelConfig?.tilt ?? null;

        const appPanelConfig = {
          moduleProperties: {
            moduleId:     panel.id,
            moduleLength: lengthM,
            moduleWidth:  widthM,
            moduleMake:   manufacturer,
            moduleSize:   pmpRef / 1000,
          },
          panelProperties: {
            characteristics: {
              cell_number:  cellNumber,
              cell_type:    cellType,
              length:       lengthM,
              manufacturer: manufacturer,
              model:        panel.model || '',
              p_mp_ref:     pmpRef,
              series:       series,
              v_max:        vMax,
              width:        widthM,
            },
            id:           panel.id,
            model:        `${manufacturer} ${panel.model || ''}`.trim(),
            image:        null,
            image_link:   null,
            is_selected:  true,
          },
          ...(existingTilt != null ? { tilt: existingTilt } : {}),
        };
        this.$stageInstance.appPanelConfig = appPanelConfig;
      }

      // Persist selection so it survives a reload
      studioDataService.setPanelSettings({ panel, inverter, inverterQuantity });

      // Keep studioStore in sync so any reactive UI and App.js reads get correct values
      this.studioStore.$patch({
        selectedPanel: panel || null,
        selectedInverter: inverter || null,
        inverterQuantity: inverterQuantity || 1,
      });

      try {
        // Set state to PANEL_VIEW_STATE BEFORE saving so the API receives the correct state
        this.studioStore.$patch({ currentAppState: PANEL_VIEW_STATE });
        this.setAppStateInLocalStorage(PANEL_VIEW_STATE);

        // Place panels using the config we just set (save happens inside placePanels)
        await this.$stageInstance.placePanels();

        // Update panelSettings with the authoritative visible panel count (post-trim).
        // This must happen AFTER placePanels() because trimming may reduce the count.
        const visiblePanelCount = this.$stageInstance.getVisiblePanelCount();
        studioDataService.setPanelSettings({
          panel, inverter, inverterQuantity,
          panelCount: visiblePanelCount,
        });

        // Hide overlay immediately and show success toast
        this.panelSettingsSaving = false;
        this.panelSettingsSavingText = '';
        this.$message({ showClose: true, message: 'Design saved', type: 'success', center: true });
        this.$stageInstance.deselectOtherSelectedMeshes(this.$stageInstance.ground);
        this.$stageInstance.dragControls.deactivate();
        setTimeout(() => { this.addTouchEvents(); }, 100);
        this.$stageInstance.initialize2D_3DControls();
        this.switch3d();
        // Mark design as saved → enable 'View proposal' CTA
        this.designSaved = true;
        // Show panel view tooltips only on first visit
        if (this._markStateVisited('panelView')) {
          if (this.isMobileView) {
            this.isTooltipShow = true;
          } else {
            this.isSolarAccessTooltip = true;
          }
        }

        // 3. Fetch solar data in background — save already happened inside placePanels()
        this.$stageInstance.fetchIrradianceAndAccess().catch((err) => {
          console.error('[LAYER] fetchIrradianceAndAccess failed:', err);
        });
      } catch (error) {
        // Revert to PANEL_SETTINGS_STATE so user can retry
        this.panelSettingsSaving = false;
        this.panelSettingsSavingText = '';
        this.$message({ showClose: true, message: 'Design not saved', type: 'error', center: true });
        this.studioStore.$patch({ currentAppState: PANEL_SETTINGS_STATE });
        this.setAppStateInLocalStorage(PANEL_SETTINGS_STATE);
        console.error('[LAYER] Panel settings save failed:', error);
      }
    },
    //STATE MANAGEMENT FUNCTIONS
    setAppStateInLocalStorage(appState = FLOOR_STATE) {
      studioDataService.setCurrentAppState(appState);
      localStorage.setItem('currentAppState', appState);
    },
    setFloorValueInLocalStorage(infoData = 0) {
      let componentJSON = localStorage.getItem('componentData') ? JSON.parse(localStorage.getItem('componentData')) : defaultComponentsData();
      componentJSON.floorValue = infoData?.floorValue||0;
      componentJSON.infoData=infoData;
      localStorage.setItem('componentData', JSON.stringify(componentJSON));
    },
    // Auto-save design to API — APP MODE only
    async saveDesignToAPI() {
      if (appMode.isWebMode()) return;
      try {
        await studioDataService.saveDesign();
      } catch (error) {
        console.error('[LAYER] Failed to save design:', error);
      }
    },
    //Random funcs
    undoFunction() {
      if (this.currentAppState === DRAWING_STATE) {
        if (this.$stageInstance.drawManager.enabled) {
            this.$stageInstance.drawManager.removePoint();
        }else{
          // position undo here
        }
      }
      if (this.currentAppState === OBSTRUCTION_STATE) {
        // this.$stageInstance.removeFromObjectsArray();
        this.$stageInstance.handleUndo();
      }
      return this.nullFunc();
    },

       //Random funcs
       redoFunction() {
      if (this.currentAppState === DRAWING_STATE) {
        if (this.$stageInstance.drawManager.enabled) {
            this.$stageInstance.drawManager.redoLastPoint();
        }else{
          // position redo here
        }
      }
      if (this.currentAppState === OBSTRUCTION_STATE) {
        this.$stageInstance.handleRedo();
      }
      return this.nullFunc();
    },

    deleteFunction() {
      if (this.currentAppState === DRAWING_STATE) {
        // Guard: only allow delete if a roof polygon actually exists and is drawn
        if (
          !this.$stageInstance.polygonModel &&
          !(this.$stageInstance.drawManager?.enabled && this.$stageInstance.drawManager?.numVertices > 0)
        ) {
          return;
        }
        if (
          this.$stageInstance.polygonModel ||
          (this.$stageInstance.drawManager?.enabled && this.$stageInstance.drawManager?.numVertices > 0)
        ) {
          // In app mode, show confirmation dialog before deleting roof
          if (appMode.isAppMode()) {
            this.deleteConfirmMessage = 'Are you sure you want to delete this roof?';
            this.pendingDeleteType = 'roof';
            this.showDeleteConfirm = true;
            return;
          }
          this._executeRoofDelete();
        }
      }
      else if (this.currentAppState === OBSTRUCTION_STATE) {
        // Guard: only allow obstruction delete if an obstruction is currently selected,
        // OR if we're in the middle of drawing an obstruction
        const hasSelectedObstruction = this.$stageInstance.currentSelectedObject instanceof Obstruction;
        const isDrawingObstruction = this.currentObstructionType === DRAW_OBSTRUCTION && this.$stageInstance.drawManager?.enabled;
        if (!hasSelectedObstruction && !isDrawingObstruction) {
          return;
        }
        // In app mode, show confirmation dialog before deleting obstruction
        if (appMode.isAppMode()) {
          this.deleteConfirmMessage = 'Are you sure you want to delete this obstruction?';
          this.pendingDeleteType = 'obstruction';
          this.showDeleteConfirm = true;
          return;
        }
        this._executeObstructionDelete();
      }

      return this.nullFunc();
    },
    _executeRoofDelete() {
      if (this.$stageInstance.drawManager.enabled) {
        this.$stageInstance.drawManager.resetDrawManager();
      } else {
        this.$stageInstance.polygonModel.removeObject();
      }
      
      // Reset all drawing-related flags
      this.$stageInstance.studioStore.$patch({ 
        basePolygonDrawn: false,
        atleast3PointsDrawn: false,
        anyPointsDrawn: false
      });
      
      // Re-initiate drawing mode so user can immediately start drawing again
      this.$stageInstance.newPolygonModel(this.infoFormData.floorValue);
    },
    _executeObstructionDelete() {
      if (this.currentObstructionType === DRAW_OBSTRUCTION) {
        if (this.$stageInstance.drawManager.enabled) {
          this.$stageInstance.drawManager.resetDrawManager();
        }
        this.$stageInstance.studioStore.$patch({ obstructionDrawn: false });
        this.$stageInstance.studioStore.$patch({ atleast3PointsDrawn: false });
      }
      this.$stageInstance.removeSelectedObject();
    },
    confirmDelete() {
      this.showDeleteConfirm = false;
      if (this.pendingDeleteType === 'roof') {
        this._executeRoofDelete();
      } else if (this.pendingDeleteType === 'obstruction') {
        this._executeObstructionDelete();
      }
      this.pendingDeleteType = null;
    },
    cancelDelete() {
      this.showDeleteConfirm = false;
      this.pendingDeleteType = null;
    },
    nullFunc() {
      console.log("null function", this.currentAppState);
    },
    addTouchEvents(){
      // Helper to safely add a touch listener (elements may not exist in all states)
      const addTouch = (id, handler) => {
        const el = document.getElementById(id);
        if (!el) return;
        el.removeEventListener('touchend', handler, false); // prevent duplicates
        el.addEventListener('touchend', handler, false);
      };
      addTouch('3dButton', this.switch3d);
      addTouch('2dButton', this.switch2d);
      addTouch('backButton', this.removeTouchEvents);
      addTouch('mainButton', this.removeTouchEvents);
      addTouch('tooltipClose', this.close2d3dTooltip);
      addTouch('solarAccess', this.switchSolarAccess);
      addTouch('irradianceMap', this.switchIrradianceMap);
    },
    removeTouchEvents(params){
      const removeTouch = (id, handler) => {
        const el = document.getElementById(id);
        if (el) el.removeEventListener('touchend', handler, false);
      };
      removeTouch('3dButton', this.switch3d);
      removeTouch('2dButton', this.switch2d);
      removeTouch('backButton', this.removeTouchEvents);
      removeTouch('mainButton', this.removeTouchEvents);
      removeTouch('solarAccess', this.switchSolarAccess);
      removeTouch('irradianceMap', this.switchIrradianceMap);

      if (params?.currentTarget?.id === 'backButton') {
        this.backFunction();
      } else if (params?.currentTarget?.id === 'mainButton') {
        this.mainActionDependingOnState();
      }
    },
    switch2d(){
      if (this.panelSettingsSaving) return;
      this.isTooltipShow = false;
      this.btn3d = false;
      this.btn2d = true;
      if(!this.$stageInstance.controlsManager){
        this.$stageInstance.initialize2D_3DControls();
      }
      this.$stageInstance.switchTo2d();
    },
    sliderChanged(){
      this.$stageInstance.obstructionScaled(this.studioStore.zoomValue);
    },
    sliderRotated(){
      this.$stageInstance.obstructionRotated(this.studioStore.rotationValue);
      this.sliderBarRotation();
    },
    switch3d(){
      if (this.panelSettingsSaving) return;
      this.isTooltipShow = false;
      this.btn3d = true;
      this.btn2d = false;
      if(!this.$stageInstance.controlsManager){
        this.$stageInstance.initialize2D_3DControls();
      }
      this.$stageInstance.switchTo3d();
      // Auto-fit camera so the whole design is properly visible on every 3D entry
      this.$stageInstance.fitCameraToDesign3D();
    },
    handleInputValueChange(value,label){
      try{
        if(label === 'floorValue'){
          this.$stageInstance.floorValue = value;
          if(this.infoFormData.floorValue && parseInt(this.infoFormData.floorValue) && (this.infoFormData.floorValue<0 || this.infoFormData.floorValue>20)) {
      this.errorData.floorValue = true;
          }else{
            this.errorData.floorValue = false;
          }
        }
        if(label === 'tariff_rate'){
          this.inputTariffValue = this.infoFormData.tariff_rate;
        }
        if(label === 'supply_phase'){
          this.infoFormData.supply_phase = value;
        }
        if(label === 'monthly_bill'){
          this.infoFormData.monthly_bill = value;
          if(this.infoFormData.monthly_bill !== null && (parseInt(this.infoFormData.monthly_bill)<1 || parseInt(this.infoFormData.monthly_bill )>9999999)){
    this.errorData.monthly_bill = true;
   }else{
    this.errorData.monthly_bill = false;
   }
        }
        if(label === 'sanction_load'){
        if(value)  {if(value<=3){
            this.infoFormData.supply_phase='Single Phase';
            this.disableRadio.isThreeDisabled=true;
            this.disableRadio.isSingleDisabled=false;

          }else if(value>5){
            this.infoFormData.supply_phase='Three Phase';
            this.disableRadio.isSingleDisabled=true;
            this.disableRadio.isThreeDisabled=false;
          }else{
            this.disableRadio.isSingleDisabled=false;
            this.disableRadio.isThreeDisabled=false;
          }}
          if (this.infoFormData.sanction_load !== null && (parseInt(this.infoFormData.sanction_load)<1 || parseInt(this.infoFormData.sanction_load )>100)) {
      this.errorData.sanction_load = true;
    }else{
     this.errorData.sanction_load = false;
  }
      }
      if(label === 'obstruction_height'){
        if(value<0.05||value>20){
          this.disableObstructionHeight=true;
      }else{
        this.disableObstructionHeight=false
        }
      }
      }catch(err){
        console.error('err: ', err);
      }

    },
    handleTariffChange(){
      this.infoFormData.tariff_rate = this.inputTariffValue;
    },
    tariffIncrementDecrement(trigger){
    if(trigger==='increase'){
      this.infoFormData.tariff_rate+=1;
      this.inputTariffValue+=1;
    }  
    if(trigger==='decrease'){
      this.infoFormData.tariff_rate-=1;
      this.inputTariffValue-=1;
    } 
  },
  obstructionHeightEntered(){
    this.setIsObstructionHeightOpen(false);
    this.$stageInstance.initDrawObstructions(this.obstructionType,this.obstructionHeight);
    this.setObstructionHeight(this.obstructionHeight);
  },
  close2d3dTooltip(){
    if(this.isTooltipShow){
      this.isTooltipShow=false;
      if(this.isMobileView){
        this.isSolarAccessTooltip=true;
        setTimeout(() => {
          let obj = document.getElementById('solarIrradiance');
        if(obj){
          obj?.addEventListener("touchend", this.close2d3dTooltip, false); 
        }
          }, 100);
      }
   
    }
   else if(this.isSolarAccessTooltip){
      this.isSolarAccessTooltip=false;
      this.isIrradianceMapTooltip=true;
    }
    else if(this.isIrradianceMapTooltip){
      this.isIrradianceMapTooltip=false;
      if(!this.isMobileView){
        this.isTooltipShow=true;
      }
    }
  },
  async switchSolarAccess(){
    if (this.panelSettingsSaving) return;
    if (this.currentAppState !== PANEL_VIEW_STATE) return;
    if (this.$stageInstance.heatSolar.apiLoading) {
      this.$message('Loading Solar Access');
    }
    else if (!this.$stageInstance.heatSolar.solarAccess) {
      try {
        await this.$stageInstance.fetchIrradianceAndAccess();
      } catch(error) {
        this.$message({
          showClose: true,
          message: error.message,
          type: "error",
          center: true,
        });
      }
    }
    else {
       if (!this.solarAccess) this.$message({
        showClose: true,
        message: "Solar Access Enabled Successfully",
        type: "success",
        center: true,
      });
      this.solarAccess = !this.solarAccess;
      this.$stageInstance.updateSolarAccess(this.solarAccess);
    }
    // this.irradianceMap=false;
  },
  async switchIrradianceMap(){
    if (this.panelSettingsSaving) return;
    if (this.currentAppState !== PANEL_VIEW_STATE) return;
    if (this.$stageInstance.heatSolar.apiLoading) {
      this.$message('Loading Irradiance Map');
    }
    else if (!this.$stageInstance.heatSolar.solarAccess) {
      try {
        await this.$stageInstance.fetchIrradianceAndAccess();
      } catch (error) {
        this.$message({
          showClose: true,
          message: error.message,
          type: "error",
          center: true,
        });
      }
    }
    else {
      if (!this.irradianceMap) this.$message({
        showClose: true,
        message: "Irradiance Map Enabled Successfully",
        type: "success",
        center: true,
      });
      this.irradianceMap = !this.irradianceMap;
      this.$stageInstance.updateIrradianceMap(this.irradianceMap);
    }
    // this.solarAccess=false;
  },
  checkFormBtn(status){
    this.formBtnDisabled=status;
  }
  }, 

  watch:{
    gifBtnToggleStore:{
      handler(val){
        this.gifBtnToggle = val;
        this.gifContent=this.gifContentForDrawing;
      }
    },
  }
};
</script>


<style  scoped>
@font-face {
  font-family: "SegoeUI";
  src: url(/fonts/SegoeUI.ttf);
}

  .layerParentContainer {
    position: fixed;
    top: 56px;
    left: 0;
    width: 100%;
    height: calc(100% - 56px);
    overflow: hidden;
    pointer-events: none;
  }

  .layerParentContainer > * {
    pointer-events: auto;
  }

  .overlay {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 2;
  }

  .backBtnContainer {
    position: absolute;
    top: 64px;
    left: 12px;
    /* padding: 11px 16px 8px 18px; */
    /* border-radius: 20px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.3);
    background-color: #fff; */
    width: 56px;
    height: 56px;
    cursor: pointer;
  }

  .backBtn {
  width:58px;
  height: 56px;
  font-size: 20px;
  background-color: #fff;
  color: #222;
  border:none;
  border-radius: 8px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
}

  .billError {
    color: rgb(214, 12, 12);
    font-size: 13px;
    margin-top: -10px;
    margin-bottom: 8px;
  }

  .undoRedoContainerOuter{
    position: absolute;
    top: 64px;
    right: 12px;
    display: flex;
    align-items: center;
    gap:16px;
  }

  .undoRedoContainer {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
    width: auto;
    max-width: 136px;
    height: 48px;
    padding: 0px 16px 1px 16px;
    border-radius: 4px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.3);
    background-color: #fff;
    cursor: pointer;
  }
  
  .layerParentContainer :deep() .el-button.is-circle {
    padding: 0px;
  }

  .iconNavBar-undo:before {
  }
  .iconNavBar-undo, .iconNavBar-undo-disabled, .resetIcon{
    font-size: 24px;
    color: #222;
  }

  .iconNavBar-undo-disabled::before {
    filter: invert(0.8);
  }

  .navBarIcon {
    border: none;
    margin-left: 0px;
  }

  .Container2d3d {
    position: absolute;
    top: 64px;
    right: 12px;
    display: flex;
    align-items: center;
    gap: 6px;
    height: 48px;
    padding: 0px 3px 1px 3px;
    border-radius: 4px;
    background-color: #fff;
  }

  .Cont2d,
  .Cont3d {
    position: relative;
    display: grid;
    place-items: center;
    width: 50px;
    height: 40px;
    color: #777;
    font-size: 16px;
    font-weight: 500;
  }

  .text2d,
  .text3d {
    font-family: "SegoeUI";
  }

  .cont2d3dActive {
    border-radius: 4px;
    background-color: var(--bgColor);
    color: #fff;
    font-weight: 600;
    width: 50px;
    height: 40px;
  }
 
  .tooltipContainer3DBtn {
    visibility: visible;
    width: 256px;
    background-color: var(--bgColor);
    color: #fff;
    position: absolute;
    z-index: 100;
    margin-left: -60px;
    padding: 10px 12px 8px 12px;
    border-radius: 4px;
  }

  .tooltip2DMobile{
    bottom: -94px;
    right: -8px;

  }

  .tooltip2DDesktop{
    bottom: -94px;
    right: 2px;

  }

  .tooltipContainer3DBtn {
    visibility: visible;
  }

  .tooltipContainer3DBtn::after {
    content: "";
    position: absolute;
    top: -14px;
    right: 8%;
    border-width: 7px;
    border-style: solid;
    border-color: transparent transparent var(--bgColor) transparent;
  }

  .tooltipText3d {
    font-size: 14px;
    color: #fff;
    font-weight: 100;
    line-height: 1.43;
    font-family: "SegoeUI";
  }

  .tooltipBtnCont {
    display: flex;
    justify-content: flex-end;
    gap: 32px;
  }

  .skipBtn,
  .nextBtn {
    color: #fff;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    font-family: "SegoeUI";
  }

  .nextBtn {
    font-weight: 600;
  }

  .sliderContainer {
    position: absolute;
    top: 216px;
    right: 0px;
  }

  .slider-demo-block {
    position: relative;
  }

  .layerParentContainer :deep() .el-slider__runway {
    width: 6px;
    background: #fff;
  }

  .layerParentContainer :deep() .el-slider__button {
    background-color: var(--bgColor);
    border: 3px solid #fff;
    margin-left: 2px;
    box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.4);
  }

.layerParentContainer>.rotSliderContainer :deep() .el-slider__button {
    background-color: transparent;
    margin-left: 2px;
    height: 34px;
    width: 34px;
    border:none
  }
  .layerParentContainer :deep() .el-slider__bar {
    background-color: var(--bgColor);
    width: 6px;
  }

  .containerMD {
    display: inherit;
    position: fixed;
    bottom: 0px;
    width: 100%;
    padding: 16px;
    padding-bottom: 0px;
    border-top-right-radius: 8px;
    border-top-left-radius: 8px;
    background-color: #fff;
  }

  .inputLabel {
    font-weight: 600;
    font-family: "SegoeUI";
    color:#777;
    font-size: 14px;
  }
  .inputLabel2 {
    font-size: 14px;
    font-weight: 600;
    font-family: "SegoeUI";
    color:#777;
    margin-top: 16px;
  } 

  .inputTag {
    height: 48px;
    width: 100%;
    font-size: 16px;
    color: #222;
    padding: 8px 16px;
    box-sizing: border-box;
    outline: none;
    border: 1px solid #999;
    border-radius: 4px;
    background-color: #fff;
    margin-bottom: 14px;
    font-family: "SegoeUI";
  }

  .drwBtnBtnMD {
    font-size: 16px;
    font-weight: 600;
    padding: 13px 17px;
    height: 48px;
    width: 100vw;
    border-radius: 0px;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.08);
    margin-left: -16px;
    font-family: "SegoeUI";
    background-color: var(--bgColor);
  }

  .drwBtnBtnDV{
    font-size: 16px;
    font-weight: 600;
    height:40px;
    background-color: var(--bgColor);

  }

  .drwBtnBtnMD:hover, .drwBtnBtnDV:hover {
    background-color: var(--bgColor);
  }

  .drwBtnBtnMD.is-disabled, .drwBtnBtnMD.is-disabled:focus, .drwBtnBtnMD.is-disabled:hover, .drwBtnBtnDV.is-disabled, .drwBtnBtnDV.is-disabled:focus, .drwBtnBtnDV.is-disabled:hover {
    color: #ccc;
    background-image: linear-gradient(to bottom, #f5f7fa, #e8edf2);
    border: none;
    border-top: 1px solid #ccc;
  }

  .layerParentContainer :deep() .el-button > span {
    font-family: "SegoeUI";
  }

  .gifContainer {
    position: fixed;
    bottom: 16px;
    right: 12px;
    z-index: 2;
  }

  .topGifContainer {
    bottom: 58px;
  }

  .bulbCont {
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.3);
    background-color: #fff;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: grid;
    place-items: center;
    cursor: pointer;
  }

  .tooltipContainer {
    visibility: visible;
    width: 328px;
    background-color: #fff;
    position: absolute;
    z-index: 100;
    bottom: 52px;
    right: 0px;
    padding: 14px 16px 22px 16px;
    border-radius: 8px;
  }

  .tooltipContainer::after {
    content: "";
    position: absolute;
    bottom: -16px;
    right: 3%;
    border-width: 9px;
    border-style: solid;
    border-color: #fff transparent transparent transparent;
  }

  .bulbIcon:hover .tooltipContainer {
    visibility: visible;
  }

  .tooltipHeading {
    font-size: 16px;
    color: #777;
    font-weight: 600;
    margin-bottom: 8px;
    font-family: "SegoeUI";
  }

  .tooltipText {
    font-size: 16px;
    color: #222;
    line-height: 1.5;
    margin-bottom: 10px;
    font-family: "SegoeUI";
  }

  .gifImg {
    width: 296px;
    height: 250px;
    object-fit: cover;
  }

  .positionR {
    position: relative;
  }

  .commonBtn {
    position: absolute;
    top: 112px;
    right: 12px;
    font-family: "SegoeUI";
    border-radius: 0px;
    background-color: var(--bgColor);
    border-color: var(--bgColor);
    height: 48px;
    width: 104px;
    border-radius: 4px;
  }
  
  .commonBtn:hover {
    background-color: var(--bgColor);
  }

  .commonBtn.is-disabled, .commonBtn.is-disabled:focus, .commonBtn.is-disabled:hover {
    color: #ccc;
    background-image: linear-gradient(to bottom, #f5f7fa, #e8edf2);
    border: none;
    border-top: 1px solid #ccc;
  }

  .rotSliderContainer {
    position: fixed;
    bottom: 60px;
    width: 75vw;
    left: 24px;
    max-width: 260px;
    z-index: 3;
  }

  .main {
  position: relative;
  }

#slider {
  -webkit-appearance: none; 
  width: 100%;
  height: 8px;
  border-radius: 4px;
}

/* Design slider button */
#slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  width: 30px;
  height: 30px;
  cursor: pointer;
  position: relative;
  z-index: 3;
}

#selector {
  width: 48px;
  position: absolute;
  bottom: -20px;
  left: 50%;
  transform: translateX(-40%);
  z-index: 2;
}

#selectValue {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  position: absolute;
  bottom: 12px;
  background: var(--bgColor);
  text-align: center;
  line-height: 28px;
  font-size: 13px;
  font-weight: bold;
  color: #fff;
  border: 3px solid #fff;
}

.sliderTooltip {
  left: 40%;
  transform: translate(-50%, 0%);
  margin: 0px;
  position: absolute;
  bottom: 56px;
  visibility: visible;
  width: 256px;
  background-color: var(--bgColor);
  color: #fff;
  position: absolute;
  z-index: 100;
  padding: 10px 12px 8px 12px;
  border-radius: 4px;
}

.sliderTooltip::after {
    content: "";
    position: absolute;
    bottom: -14px;
    left: 50%;
    border-width: 7px;
    border-style: solid;
    transform: translate(-50%, 0%);
    border-color:var(--bgColor) transparent  transparent  transparent;
  }

  .sliderTooltipTwo {
  right: 48px;
  position: absolute;
  bottom: 8%;
  visibility: visible;
  width: 260px;
  background-color: var(--bgColor);
  color: #fff;
  position: absolute;
  z-index: 100;
  padding: 10px 12px 8px 12px;
  border-radius: 4px;
}

.sliderTooltipTwo::after {
    content: "";
    position: absolute;
    top: 50%;
    right: -5%;
    border-width: 7px;
    border-style: solid;
    transform: translate(0%, -50%);
    border-color:  transparent  transparent  transparent var(--bgColor);
  }

#progressBar {
  width: 50%;
  height: 8px;
  background: var(--bgColor);
  border-radius: 3px;
  position: absolute;
  bottom: 3px;
  left: 0;
}
.inputTag::placeholder{
  color:#777 !important;
  font-size: 14px !important;
  font-weight: 400 !important;
}
.info-container{
  padding-bottom: 16px;
  display: grid;
  row-gap: 16px;
}
.info-content{
  display:grid;
  row-gap: 8px;
}
.smLabel{
    font-size: 12px;
  }
  .mdLabel{
    font-size: 14px;
  }
  .ContainerSolaAccess{
    position: absolute;
    top: 150px;
    right: 8px;
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 0px 3px 1px 3px;
    border-radius: 4px;

  }

  .tooltipContainerSolarAccessBtn {
    visibility: visible;
    width: 256px;
    background-color: var(--bgColor);
    color: #fff;
    position: absolute;
    z-index: 100;
    right: -8px;
    margin-left: -60px;
    padding: 10px 12px 8px 12px;
    border-radius: 4px;
  }
 
  .change-bottom-solarAccess{
    bottom: -8px;
  }

  .change-bottom-irradiance{
    bottom: -64px;
  }
  
  .bottomPosition{
    top:60px;
  }
  .solarAccessRight{
    right:348px;
  }
.irradianceRight{
  right: 280px;
}

.layerParentContainer>.containerMD :deep() .el-slider__bar {
    width: 6px;
    background: #006eaf !important;
  }
  .layerParentContainer>.containerMD :deep() .el-slider__button {
  border: 3px solid var(--White, #fff);
  background: var(--Primary, #006eaf);
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.5);
  height: 15px;
  width: 15px;
}
.layerParentContainer>.containerMD :deep() .el-slider__runway {
 background-color: #ccc !important;
 width: 6px;
}
  .tariff-container{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .tariff-input{ 
    display: flex;
  align-items: center;
  justify-content: end;
  gap: 8px;
  }
  .tariff-input-box {
  border-radius: 4px;
  border: 1px solid var(--999, #999);
  background: var(--White, #fff);
  width: 80px;
  padding: 5px;
  display: flex;
  align-items: center;
  height: 40px;
}
.time_input {
  outline: none;
  border: none;
  width: 30px;
}
.tariff-slider{
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  width: 100%;
}
.tariff-range-max{
  width: 36px;
}
.tariff-range-min{
  width: auto;
}
.triff-inc-dec{
  display: flex;
  justify-content: center;
  align-items: center;
 border-radius: 50%;
 border: 1px solid #222;
 width:16px;
 height: 16px;
 background-color: #222;
 color: #fff;
 font-size: 14px;
 font-weight: 600;
}
.layerParentContainer>.containerMD :deep() .el-input-group__append {
  box-shadow: none;
  background-color: white;
  padding: 0;
}

.layerParentContainer>.containerMD :deep() .el-input__inner {
  color: black;
  background-color: white !important;
}

.layerParentContainer>.containerMD :deep() .el-input__wrapper {
  box-shadow: none;
  padding-left: 1px;
}
.layerParentContainer>.containerMD :deep() .el-input-group{
  border:1px solid #777;
  padding: 8px 16px;
  border-radius: 4px;

}
.layerParentContainer>.containerMD :deep() .el-input__inner::placeholder{
  color: #777 !important;
  font-size: 14px !important;
  font-weight: 400 !important;
}

.containerDV :deep() .el-input-group__append {
  box-shadow: none;
  background-color: white;
  padding: 0;
}

.containerDV :deep() .el-input__inner {
  color: black;
  background-color: white !important;
}

.containerDV :deep() .el-input__wrapper {
  box-shadow: none;
  padding-left: 1px;
}
.containerDV :deep() .el-input-group{
  border:1px solid #777;
  padding: 8px 16px;
  border-radius: 4px;

}
.containerDV :deep() .el-input__inner::placeholder{
  color: #777 !important;
  font-size: 14px !important;
  font-weight: 400 !important;
}




.custom-slider-tooltip {
  background-color: #3498db !important;  /* Change background color */
  color: white !important;              /* Change text color */
  border-radius: 8px !important;        /* Add rounded corners */
  font-weight: bold !important;         /* Make text bold */
  padding: 5px 10px !important;         /* Adjust padding */
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2) !important;
}
.layerParentContainer>.containerMD :deep() .el-radio__input.is-checked .el-radio__inner {
  border-color: #006eaf;
    background-color: #fff;
    border: 2px solid #006eaf;

}
.layerParentContainer>.containerMD :deep() .el-radio__inner::after {
  height: 7px;
  width: 7px;
  background-color: #006eaf;
  left: 50%;
  top: 50%;
}
.layerParentContainer :deep() .el-button.is-plain{
  background-color: none !important;

}
.layerParentContainer>.containerMD :deep() .el-radio__input.is-checked+.el-radio__label{
  color:#006eaf;
}
.warning{
  color:red;
  font-size: 12px;
}
.icon-container{
  background-color: #fff;
  width: 48px;
  height: 48px;
  border-radius: 8px;
  border:1px solid #ccc;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.selectedSolarAccess{
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 4px;
    background-color:var(--bgColor);
    color: #fff;
    font-weight: 600;

}

.layerParentContainer :deep() .el-dialog__header {
  display: none;
}
.layerParentContainer :deep() .el-dialog {
border-radius: 8px;
}

.dialog-footer{
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
}
.btn-content{
  width:134px;
  height: 40px;
}
.btn-color{
  background-color: var(--bgColor);
}

.btn-content.is-disabled, .btn-content.is-disabled:focus, .btn-content.is-disabled:hover {
    color: #ccc;
    background-image: linear-gradient(to bottom, #f5f7fa, #e8edf2);
    border: none;
  }

  .commonBtnDV{
    height: 48px;
    width: 100%;
    padding:8px 16px;
    background-color: var(--bgColor);
    border-color: var(--bgColor);

  }

  .Container2d3dDV {
    position: absolute;
    top: 64px;
    right: 12px;
    height: 48px;
    padding: 0px 8px 1px 8px;
    border-radius: 4px;
    display: flex;
    justify-content: space-between;
    gap:24px;
  }
  .container2d3dbtns{
    background-color: #fff;
    height: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding:8px 4px ;
    border-radius: 4px;
    cursor: pointer;
  }

  .ContainerSolarIrradiance{
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap:16px;
    cursor: pointer;
  }

  .showOnOverlay{
    position: relative;
    z-index: 20;
  }
  .showOnOverlayMD{
    position: absolute;
    z-index: 20;
   
  }
  
  .slider-container {
  position: relative;
  width: 300px;
}

.custom-slider {
  width: 100%;
}

.custom-thumb {
  position: absolute;
  top: -4px;
  transform: translateX(-50%);
  background-color:var(--bgColor);
  color: white;
  border-radius: 50%;
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  border:3px solid #fff;
  font-size: 12px;
}
  .saving-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,0.45);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    pointer-events: auto;
  }
  .saving-card {
    background: #fff;
    border-radius: 12px;
    padding: 24px 28px;
    min-width: 260px;
    box-shadow: 0 10px 24px rgba(0,0,0,0.18);
    display: flex;
    align-items: center;
    gap: 12px;
  }
  .spinner {
    width: 22px;
    height: 22px;
    border: 3px solid #e5e7eb;
    border-top-color: #409EFF;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }
  .saving-text { font-weight: 600; color: #111827; }
  @keyframes spin { to { transform: rotate(360deg); } }
@media (max-width: 1100px) {
  .layerParentContainer {
    top: 56px;
    height: calc(100% - 56px);
  }

  .undoRedoContainerOuter,.backBtnContainer,.Container2d3d{
    top:64px;
  }

  .undoRedoContainerOuter{
    right:12px;
  }

  .commonBtn{
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 48px;
    font-size: 18px;
    font-weight: 600;
    top:auto;
    right:0px;
  }

  .sliderContainer {
    top: 152px;
  }

}

@media (max-width: 500px) {
  .layerParentContainer {
    top: 10px;
    height: calc(100% - 75px);
  }

  .undoRedoContainerOuter,.backBtnContainer,.Container2d3d{
    top:83px;
  }

  .sliderContainer {
    top: 164px;
  }
}
</style>

